{
  "version": 1,
  "asset_id": "210f6d40-f81a-4eef-90bb-06dc903559b7",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/210f6d40-f81a-4eef-90bb-06dc903559b7/destination-roofing-blue-metal-roof-lecanto-fl-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/210f6d40-f81a-4eef-90bb-06dc903559b7/destination-roofing-blue-metal-roof-lecanto-fl-480w.webp",
  "original_filename": "destination-roofing-blue-metal-roof-lecanto-fl-480w.webp",
  "size": 24054,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:15Z"
}
